<template>
  <div v-if="mvm" class="info">
    <div v-if="dvm">
      <el-row>
        <el-col>
          <h2>機台編號：{{ mvm.AssetNo }}</h2>
          <h3 v-show="mvm.client">客戶名稱： {{ mvm.client && mvm.client.customer_code }} {{ mvm.client && mvm.client.name }}</h3>
          <h3 v-show="mvm.op_locate">機台位置：{{ mvm.op_locate && mvm.op_locate.location_code }} {{ mvm.op_locate && mvm.op_locate.location_name }}</h3>
          <h3>發票是否啟用：{{ mvm.invoice_settings.Invoice ? '啟用' : '不啟用' }}</h3>
          <h3>發票啟用起始時間：{{ mvm.invoice_settings.EnableSince }}</h3>
          <h3>是否列印發票：{{ dvm.setting.printInvoice | printInvoiceFilter }}</h3>
          <h3>是否列印明細：{{ dvm.setting.printReceipt | printDetailFilter }}</h3>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="gates">
          <h3 class="gate-section-title">即時貨道</h3>
          <el-row>
            <el-col :lg="6" :sm="12" :xs="24" v-for="(gate, index) of dvm.gates" :key="index">
              <div class="gate-status" :class="gate | statusFilter">
                <div class="gate-status-header">
                  <div>
                    <h2>貨道 {{ gate.GateNo }}</h2>
                    <div class="hardware-gate-display">硬體貨道 {{ gate.HardwareGateNo || gate.GateNo }}</div>
                  </div>
                  <span class="gate-status-badge">{{ gate | statusTextFilter }}</span>
                </div>
                <div class="gate-product-name" :title="gate.Product.ProductNa">{{ gate.Product.ProductNa || '未設定商品' }}</div>
                <div class="gate-metrics">
                  <div class="gate-metric">
                    <span>售價</span>
                    <strong>{{ gate.Product.UnitPrice || gate.Price || 0 }}</strong>
                  </div>
                  <div class="gate-metric">
                    <span>庫存</span>
                    <strong>{{ gate.Stock }}</strong>
                  </div>
                  <div class="gate-metric">
                    <span>銷售</span>
                    <strong>{{ gate.Sales }}</strong>
                  </div>
                  <div class="gate-metric">
                    <span>缺補</span>
                    <strong>{{ gate.Short }}</strong>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="hardware-gate-panel">
            <div class="hardware-gate-toolbar">
              <div>
                <h3 class="hardware-gate-title">硬體貨道對照設定</h3>
                <span class="hardware-gate-summary">已變更 {{ dirtyHardwareGateRows.length }} 筆</span>
              </div>
              <div class="hardware-gate-actions">
                <div class="sequence-field">
                  <span>前綴文字</span>
                  <el-input v-model="sequencePrefix" size="mini" class="sequence-prefix" placeholder="無前綴" clearable />
                </div>
                <div class="sequence-field">
                  <span>起始號碼</span>
                  <el-input-number v-model="sequenceStart" size="mini" controls-position="right" :min="0" class="sequence-start" />
                </div>
                <div class="sequence-field">
                  <span>補零位數</span>
                  <el-input-number v-model="sequencePad" size="mini" controls-position="right" :min="0" :max="4" class="sequence-pad" />
                </div>
                <span class="sequence-preview">範例：{{ sequencePreview }}</span>
                <el-button size="mini" @click="applySequence">依序套用</el-button>
                <el-button size="mini" @click="pasteDialogVisible = true">貼上對照表</el-button>
                <el-button size="mini" @click="resetHardwareGateRows" :disabled="dirtyHardwareGateRows.length === 0">重設</el-button>
                <el-button size="mini" type="primary" :loading="savingHardwareGates" :disabled="dirtyHardwareGateRows.length === 0" @click="saveHardwareGateRows">儲存全部</el-button>
              </div>
            </div>
            <div class="hardware-gate-grid">
              <div v-for="row in hardwareGateRows" :key="row.GateNo" class="hardware-gate-row" :class="{ dirty: isHardwareGateRowDirty(row) }">
                <div class="hardware-gate-row-main">
                  <div class="hardware-gate-no">貨道 {{ row.GateNo }}</div>
                  <div class="hardware-gate-product" :title="row.ProductNa">{{ row.ProductNa || '未設定商品' }}</div>
                </div>
                <div class="hardware-gate-current">
                  <span>目前</span>
                  <strong>{{ row.OriginalHardwareGateNo }}</strong>
                </div>
                <el-input v-model="row.HardwareGateNo" size="small" class="hardware-gate-edit-input" />
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-dialog title="貼上硬體貨道對照" :visible.sync="pasteDialogVisible" width="520px" append-to-body>
        <el-input v-model="pasteText" type="textarea" :rows="10" placeholder="每行一筆：貨道	硬體貨道，例如 1	A1" />
        <span slot="footer">
          <el-button @click="pasteDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="applyPasteText">套用</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getMvm, updateHardwareGateNumbers } from '@/api/mvms';
export default {
  filters: {
    statusFilter(gate) {
      return !gate.Product.ProductNa ? 'none' : gate.Short !== 0 ? 'short' : 'ok';
    },
    statusTextFilter(gate) {
      return !gate.Product.ProductNa ? '未設定' : gate.Short !== 0 ? '缺補' : '正常';
    },
    printInvoiceFilter(key) {
      const map = {
        true: '列印發票',
        false: '不印發票',
      };
      return key ? map[key] : '不印發票';
    },
    printDetailFilter(key) {
      const map = {
        true: '列印明細',
        false: '不印明細',
      };
      return key ? map[key] : '不印明細';
    },
  },
  props: {
    id: null,
  },
  data() {
    return {
      dvm: null,
      mvm: null,
      hardwareGateRows: [],
      savingHardwareGates: false,
      sequencePrefix: '',
      sequenceStart: 1,
      sequencePad: 0,
      pasteDialogVisible: false,
      pasteText: '',
    };
  },
  async created() {
    try {
      let mvm = await getMvm(this.id);
      if (typeof mvm === 'string') {
        mvm = JSON.parse(mvm);
      }
      let dvm = mvm.dvm;
      if (typeof dvm === 'string') {
        dvm = JSON.parse(dvm);
        mvm.dvm = dvm;
      }
      // console.log(`[views/mvms/components/info.vue] mvm: ${JSON.stringify(mvm)}`);
      // console.log(`[views/mvms/components/info.vue] dvm: ${JSON.stringify(dvm)}`);
      dvm.gates = dvm.gates.gates ? dvm.gates.gates : dvm.gates;
      dvm.gates.forEach((gate) => {
        this.$set(gate, 'HardwareGateNo', gate.HardwareGateNo || gate.GateNo);
      });
      this.dvm = dvm;
      this.mvm = mvm;
      this.resetHardwareGateRows();
    } catch (error) {
      console.error(`created error: ${error}`);
    }
  },
  computed: {
    dirtyHardwareGateRows() {
      return this.hardwareGateRows.filter((row) => `${row.HardwareGateNo}`.trim() !== `${row.OriginalHardwareGateNo}`.trim());
    },
    sequencePreview() {
      return this.formatSequenceValue(0);
    },
  },
  methods: {
    resetHardwareGateRows() {
      if (!this.dvm || !this.dvm.gates) return;
      this.hardwareGateRows = this.dvm.gates.map((gate) => {
        const hardwareGateNo = `${gate.HardwareGateNo || gate.GateNo}`;
        return {
          GateNo: `${gate.GateNo}`,
          ProductNa: (gate.Product && gate.Product.ProductNa) || '',
          HardwareGateNo: hardwareGateNo,
          OriginalHardwareGateNo: hardwareGateNo,
        };
      });
    },
    isHardwareGateRowDirty(row) {
      return `${row.HardwareGateNo}`.trim() !== `${row.OriginalHardwareGateNo}`.trim();
    },
    formatSequenceValue(index) {
      const numberText = `${this.sequenceStart + index}`;
      const padded = this.sequencePad > 0 ? numberText.padStart(this.sequencePad, '0') : numberText;
      const prefix = this.sequencePrefix === null || this.sequencePrefix === undefined ? '' : `${this.sequencePrefix}`.trim();
      return `${prefix}${padded}`;
    },
    applySequence() {
      this.hardwareGateRows.forEach((row, index) => {
        this.$set(row, 'HardwareGateNo', this.formatSequenceValue(index));
      });
    },
    applyPasteText() {
      const byGateNo = new Map(this.hardwareGateRows.map((row) => [String(row.GateNo), row]));
      this.pasteText
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .forEach((line) => {
          const [gateNo, hardwareGateNo] = line.split(/[\t,，\s]+/);
          const target = byGateNo.get(String(gateNo));
          if (target && hardwareGateNo) {
            this.$set(target, 'HardwareGateNo', hardwareGateNo);
          }
        });
      this.pasteDialogVisible = false;
      this.pasteText = '';
    },
    syncRowsToGates(rows) {
      const byGateNo = new Map(rows.map((row) => [String(row.GateNo), row]));
      this.dvm.gates.forEach((gate) => {
        const row = byGateNo.get(String(gate.GateNo));
        if (row) {
          this.$set(gate, 'HardwareGateNo', `${row.HardwareGateNo}`.trim() || `${gate.GateNo}`);
        }
      });
    },
    async saveHardwareGateRows() {
      try {
        const changedRows = this.dirtyHardwareGateRows.map((row) => ({
          GateNo: `${row.GateNo}`,
          HardwareGateNo: `${row.HardwareGateNo}`.trim() || `${row.GateNo}`,
        }));
        if (changedRows.length === 0) return;
        this.savingHardwareGates = true;
        await updateHardwareGateNumbers({
          AssetNo: this.mvm.AssetNo,
          items: changedRows,
        });
        this.syncRowsToGates(changedRows);
        this.resetHardwareGateRows();
        this.$message.success(`已更新 ${changedRows.length} 筆硬體貨道`);
      } catch (error) {
        console.error(`saveHardwareGateRows error: ${error}`);
        this.$message.error('批次更新硬體貨道失敗');
      } finally {
        this.savingHardwareGates = false;
      }
    },
  },
};
</script>
<style scoped>
.info {
  overflow: scroll;
}

.gates {
  overflow: scroll;
}

.gate-section-title {
  margin: 12px 6px 6px;
  color: #303133;
  font-size: 20px;
}

.hardware-gate-panel {
  margin: 12px 0 16px;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #f7f9fb;
}

.hardware-gate-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.hardware-gate-title {
  margin: 0 0 4px;
  font-size: 20px;
}

.hardware-gate-summary {
  color: #606266;
  font-size: 15px;
}

.hardware-gate-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.sequence-field {
  display: flex;
  align-items: center;
  gap: 4px;
}

.sequence-field span,
.sequence-preview {
  color: #606266;
  font-size: 13px;
  white-space: nowrap;
}

.sequence-preview {
  padding: 0 4px;
}

.sequence-prefix {
  width: 72px;
}

.sequence-start,
.sequence-pad {
  width: 96px;
}

.hardware-gate-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 8px;
  max-height: 420px;
  overflow: auto;
}

.hardware-gate-row {
  display: grid;
  grid-template-columns: minmax(150px, 1fr) 92px 132px;
  align-items: center;
  gap: 10px;
  min-height: 58px;
  padding: 8px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #ffffff;
}

.hardware-gate-row.dirty {
  background: #fff7e6;
  border-color: #f5c26b;
}

.hardware-gate-row-main {
  min-width: 0;
}

.hardware-gate-no {
  color: #303133;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
}

.hardware-gate-product {
  overflow: hidden;
  color: #606266;
  font-size: 15px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hardware-gate-current {
  color: #606266;
  font-size: 14px;
  line-height: 1.25;
}

.hardware-gate-current span {
  display: block;
}

.hardware-gate-current strong {
  color: #303133;
  font-size: 18px;
}

.hardware-gate-edit-input {
  width: 132px;
}

::v-deep .hardware-gate-edit-input .el-input__inner {
  height: 36px;
  font-size: 18px;
  font-weight: 700;
}

.hardware-gate-display {
  margin-bottom: 8px;
  font-size: 15px;
  font-weight: 700;
}

@media (max-width: 520px) {
  .hardware-gate-grid {
    grid-template-columns: 1fr;
  }

  .hardware-gate-row {
    grid-template-columns: 1fr;
    align-items: stretch;
  }

  .hardware-gate-edit-input {
    width: 100%;
  }
}

.m0 {
  margin: 0;
}

.gate-status {
  min-height: 182px;
  margin: 6px;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #ffffff;
  color: #303133;
}

.gate-status-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.gate-status-header h2 {
  margin: 0 0 4px;
  font-size: 22px;
  line-height: 1.2;
}

.gate-status-badge {
  flex: 0 0 auto;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
}

.gate-status.none {
  border-color: #c0c4cc;
}

.gate-status.none .gate-status-badge {
  background: #f4f4f5;
  color: #606266;
}

.gate-status.short {
  border-color: #e6a23c;
  background: #fffaf0;
}

.gate-status.short .gate-status-badge {
  background: #fdf1dc;
  color: #b56b00;
}

.gate-status.ok {
  border-color: #67c23a;
}

.gate-status.ok .gate-status-badge {
  background: #edf8e9;
  color: #2f7d18;
}

.gate-product-name {
  overflow: hidden;
  min-height: 28px;
  margin: 8px 0;
  color: #303133;
  font-size: 18px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gate-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

.gate-metric {
  padding: 7px 6px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #f7f9fb;
  text-align: center;
}

.gate-metric span {
  display: block;
  color: #606266;
  font-size: 13px;
  line-height: 1.2;
}

.gate-metric strong {
  display: block;
  margin-top: 2px;
  color: #303133;
  font-size: 20px;
  line-height: 1.2;
}

@media (max-width: 420px) {
  .gate-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.my-header {
  padding: 0px;
}

th {
  font-size: 2rem;
}
</style>
